{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "ranks": {
    "exobiology": [],
    "combat": [
      {
        "rank": 0,
        "name": "Harmless"
      },
      {
        "rank": 1,
        "name": "MostlyHarmless"
      },
      {
        "rank": 2,
        "name": "Novice"
      },
      {
        "rank": 3,
        "name": "Competent"
      },
      {
        "rank": 4,
        "name": "Expert"
      },
      {
        "rank": 5,
        "name": "Master"
      },
      {
        "rank": 6,
        "name": "Dangerous"
      },
      {
        "rank": 7,
        "name": "Deadly"
      },
      {
        "rank": 8,
        "name": "Elite"
      },
      {
        "rank": 9,
        "name": "Elite I"
      },
      {
        "rank": 10,
        "name": "Elite II"
      },
      {
        "rank": 11,
        "name": "Elite III"
      },
      {
        "rank": 12,
        "name": "Elite IV"
      },
      {
        "rank": 13,
        "name": "Elite V"
      }
    ],
    "trade": [
      {
        "rank": 0,
        "name": "Penniless"
      },
      {
        "rank": 1,
        "name": "Mostly Penniless"
      },
      {
        "rank": 2,
        "name": "Peddler"
      },
      {
        "rank": 3,
        "name": "Dealer"
      },
      {
        "rank": 4,
        "name": "Merchant"
      },
      {
        "rank": 5,
        "name": "Broker"
      },
      {
        "rank": 6,
        "name": "Entrepreneur"
      },
      {
        "rank": 7,
        "name": "Tycoon"
      },
      {
        "rank": 8,
        "name": "Elite"
      },
      {
        "rank": 9,
        "name": "Elite I"
      },
      {
        "rank": 10,
        "name": "Elite II"
      },
      {
        "rank": 11,
        "name": "Elite III"
      },
      {
        "rank": 12,
        "name": "Elite IV"
      },
      {
        "rank": 13,
        "name": "Elite V"
      }
    ],
    "exploration": [
      {
        "rank": 0,
        "name": "Aimless"
      },
      {
        "rank": 1,
        "name": "Mostly Aimless"
      },
      {
        "rank": 2,
        "name": "Scout"
      },
      {
        "rank": 3,
        "name": "Surveyor"
      },
      {
        "rank": 4,
        "name": "Explorer"
      },
      {
        "rank": 5,
        "name": "Pathfinder"
      },
      {
        "rank": 6,
        "name": "Ranger"
      },
      {
        "rank": 7,
        "name": "Pioneer"
      },
      {
        "rank": 8,
        "name": "Elite"
      },
      {
        "rank": 9,
        "name": "Elite I"
      },
      {
        "rank": 10,
        "name": "Elite II"
      },
      {
        "rank": 11,
        "name": "Elite III"
      },
      {
        "rank": 12,
        "name": "Elite IV"
      },
      {
        "rank": 13,
        "name": "Elite V"
      }
    ],
    "federation": [
      {
        "rank": 0,
        "name": "None"
      },
      {
        "rank": 1,
        "name": "Recruit"
      },
      {
        "rank": 2,
        "name": "Cadet"
      },
      {
        "rank": 3,
        "name": "Midshipman"
      },
      {
        "rank": 4,
        "name": "Petty Officer"
      },
      {
        "rank": 5,
        "name": "Chief Petty Officer"
      },
      {
        "rank": 6,
        "name": "Warrant Officer"
      },
      {
        "rank": 7,
        "name": "Ensign"
      },
      {
        "rank": 8,
        "name": "Lieutenant"
      },
      {
        "rank": 9,
        "name": "Lt Commander"
      },
      {
        "rank": 10,
        "name": "Post Commander"
      },
      {
        "rank": 11,
        "name": "Post Captain"
      },
      {
        "rank": 12,
        "name": "Rear Admiral"
      },
      {
        "rank": 13,
        "name": "Vice Admiral"
      },
      {
        "rank": 14,
        "name": "Admiral"
      }
    ],
    "empire": [
      {
        "rank": 0,
        "name": "None"
      },
      {
        "rank": 1,
        "name": "Outsider"
      },
      {
        "rank": 2,
        "name": "Serf"
      },
      {
        "rank": 3,
        "name": "Master"
      },
      {
        "rank": 4,
        "name": "Squire"
      },
      {
        "rank": 5,
        "name": "Knight"
      },
      {
        "rank": 6,
        "name": "Lord"
      },
      {
        "rank": 7,
        "name": "Baron"
      },
      {
        "rank": 8,
        "name": "Viscount"
      },
      {
        "rank": 9,
        "name": "Count"
      },
      {
        "rank": 10,
        "name": "Earl"
      },
      {
        "rank": 11,
        "name": "Marquis"
      },
      {
        "rank": 12,
        "name": "Duke"
      },
      {
        "rank": 13,
        "name": "Prince"
      },
      {
        "rank": 14,
        "name": "King"
      }
    ],
    "cqc": [
      {
        "rank": 0,
        "name": "Helpless"
      },
      {
        "rank": 1,
        "name": "Mostly Helpless"
      },
      {
        "rank": 2,
        "name": "Amateur"
      },
      {
        "rank": 3,
        "name": "Semi Professional"
      },
      {
        "rank": 4,
        "name": "Professional"
      },
      {
        "rank": 5,
        "name": "Champion"
      },
      {
        "rank": 6,
        "name": "Hero"
      },
      {
        "rank": 7,
        "name": "Legend"
      },
      {
        "rank": 8,
        "name": "Elite"
      },
      {
        "rank": 9,
        "name": "Elite I"
      },
      {
        "rank": 10,
        "name": "Elite II"
      },
      {
        "rank": 11,
        "name": "Elite III"
      },
      {
        "rank": 12,
        "name": "Elite IV"
      },
      {
        "rank": 13,
        "name": "Elite V"
      }
    ]
  }
}
